import GenericDB from './generic-db'

export default class ReservationsDB extends GenericDB {
  constructor() {
    super('reservations')
  }

  // Here you can extend ReservationsDB with custom methods
}
